import { Component, OnChanges, OnInit, OnDestroy, AfterViewInit, AfterViewChecked } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';
import { GridOptionsModel, ColumnDefinitionsModel, PaginationsModel } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { SignupService } from './shared/providers/signup.service';
import { Router } from '@angular/router';
import { BreadCrumbModel, StepIndicatorModel, StepIndicatorService, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components';
import { BREADCRUMBS, STEPINDICATORS } from 'config';


@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
  providers: [StepIndicatorService, SignupService]
})

export class SignUpComponent implements OnInit, OnDestroy {
  stepIndicators: StepIndicatorModel[];
  displayFlag: boolean;
  sessionName: string;
  emmProductCode: any;
  currentStep: any;

  constructor(private stepindicatorService: StepIndicatorService,
    private breadCrumbService: BreadCrumbService,
    private signupService: SignupService,
    private router: Router) {

  }

  ngOnInit() {
    if (this.emmProductCode === 'ADDPMDM'){
      this.router.navigate(['/home']);
    }
    this.breadCrumbService.setCurrentBreadCrumb({ label: 'Device enrollment', routerLink: '/signup' });
    // this.emmProductCode = this.signupService.getSelectedProdCode();
    this.emmProductCode = JSON.parse(this.signupService.getSelectedProdCode()).emmProductCode;
    // this.emmProductCode = sessionStorage.getItem('emmProductCode');

    if (this.emmProductCode === 'DMPSKME' || this.emmProductCode === 'DMPGZTP') {
      this.sessionName = 'signUpOem';
      this.stepIndicators = STEPINDICATORS.signUpOem;

    } else {
      this.sessionName = 'signup';
      this.stepIndicators = STEPINDICATORS.signUp;
    }
    if (this.stepindicatorService.getSteps(this.sessionName) === null) {
      this.stepindicatorService.setSteps(this.stepIndicators, this.sessionName);
    }
    this.stepIndicators = this.stepindicatorService.getSteps(this.sessionName);
    this.stepindicatorService.getVisibility().subscribe(
      (status: boolean) => {
        this.displayFlag = status;
      }
    );

    this.stepindicatorService.getCurrentStep().subscribe(
      (path: string) => {
        this.currentStep = path +' step';
      });
  }

  ngOnDestroy() {
    this.signupService.removeSignupModel();
    sessionStorage.removeItem('SignupBacktoCallingPage');
    sessionStorage.removeItem('backupProfiles');
    sessionStorage.removeItem('ProfileSize');
  }
}